/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/QrCode.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const QrCode: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" viewBox="0 0 18 18" ref={ref} {...props}>
    <path
      fill={color}
      fillRule="evenodd"
      d="M3 2.25h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75H3A.75.75 0 0 1 2.25 6V3A.75.75 0 0 1 3 2.25M.75 3A2.25 2.25 0 0 1 3 .75h3A2.25 2.25 0 0 1 8.25 3v3A2.25 2.25 0 0 1 6 8.25H3A2.25 2.25 0 0 1 .75 6zM3 11.25h3a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 .75-.75M.75 12A2.25 2.25 0 0 1 3 9.75h3A2.25 2.25 0 0 1 8.25 12v3A2.25 2.25 0 0 1 6 17.25H3A2.25 2.25 0 0 1 .75 15zM15 2.25h-3a.75.75 0 0 0-.75.75v3c0 .414.336.75.75.75h3a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75m-3-1.5A2.25 2.25 0 0 0 9.75 3v3A2.25 2.25 0 0 0 12 8.25h3A2.25 2.25 0 0 0 17.25 6V3A2.25 2.25 0 0 0 15 .75zM9.75 16.5a.75.75 0 0 0 1.5 0V12a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 0 0-1.5H12A2.25 2.25 0 0 0 9.75 12z"
      clipRule="evenodd"
    />
  </svg>
);
QrCode.displayName = "QrCode";
